import { AxiosResponse } from 'axios'
import { axiosInstance } from 'axiosInstance'
import { USER_URLS } from 'config/urls'

export const updateUserRegion = ({
    region,
}: {
    region: string
}): Promise<AxiosResponse> =>
    axiosInstance.put(USER_URLS.updateRegion.replace('{userRegion}', region))

export const updateFirstPaymentRedirectCompleted = () => {
    axiosInstance.post(USER_URLS.firstPaymentRedirectCompleted)
}
